export const i18n = (key, translations) => translations[key] || '';
